<template>
  <div>
    <v-form ref="form" v-model="valid">
      <v-card elevation="0" class="mt-2">
        <v-card-text>
          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="3">귀속년월</v-col>
              <v-col>
                <v-select
                  v-model="selYear"
                  :items="years"
                  label="년"
                ></v-select>
                <v-select
                  v-model="selMonth"
                  :items="months"
                  label="월"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">작성일</v-col>
              <v-col>{{ today }}</v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="3">부서</v-col>
              <v-col>{{ data.deptNm }}</v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="3">직급</v-col>
              <v-col>{{ data.empRankNm }}</v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="3">신청자</v-col>
              <v-col>{{ data.empNm }}</v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="3">합계</v-col>
              <v-col>￦{{ total }}</v-col>
            </v-row>
          </v-col>
          <v-row>
            <v-col cols="4">
              <div @drop.prevent="addDropFile" @dragover.prevent>
                <v-file-input
                  chips
                  multiple
                  label="서류 첨부"
                  @change="changeFiles"
                  :value="files"
                  truncate-length="15"
                ></v-file-input>
              </div>
            </v-col>
          </v-row>
          <v-row v-for="row in rows" :key="row.seq" align="center">
            <v-col cols="2">
              <v-text-field
                v-model="row.subject"
                label="계정과목"
                clearable
                :rules="[rules.required]"
                @change="handleChangeRows(row.seq)"
              >
                <template v-slot:prepend>
                  <span class="mt-1 mr-1 text-center">{{ row.seq }}</span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="row.userNm"
                label="거래처/사용자"
                clearable
                :rules="[rules.required]"
                @change="handleChangeRows(row.seq)"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="row.summary"
                label="적요"
                clearable
                :rules="[rules.required]"
                @change="handleChangeRows(row.seq)"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                prepend-inner-icon="mdi-currency-krw"
                v-model="row.cash"
                label="금액"
                clearable
                :rules="[rules.required]"
                @keyup="setComma(row.seq, row.cash)"
                @change="sumTotal(row.seq)"
              >
                <template v-slot:append-outer>
                  <v-btn v-if="row.seq === 1" icon @click="addRows()">
                    <v-icon>mdi-plus-circle-outline</v-icon>
                  </v-btn>
                  <v-btn v-else icon @click="removeRow(row.seq)"
                    ><v-icon>mdi-minus-circle-outline</v-icon></v-btn
                  >
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-card-actions class="d-flex justify-center">
            <v-btn elevation="0" outlined color="primary" to="/approval/list"
              >취소</v-btn
            >
            <v-btn elevation="0" color="primary" @click="onSubmit">저장</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-form>
    <v-snackbar v-model="snackbar.show" timeout="1000">
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import { detailDsbr, modyDsbr, setDsbr } from "@/api/approval";
import { uploadFile } from "@/api/common";
import SetComma from "@/mixins/SetComma";
import getDates from "@/mixins/getDates";

export default {
  data() {
    return {
      headers: [
        { text: "No.", value: "seq" },
        { text: "계정과목", value: "subject" },
        { text: "거래처/사용자", value: "userNm" },
        { text: "적요", value: "summary" },
        { text: "금액", value: "cash" },
        { text: "", value: "actions" },
      ],
      valid: true,
      rules: {
        required: value => !!value || "필수 항목입니다.",
      },
      initRows: { subject: "", userNm: "", summary: "", amt: "", cash: "" },
      rows: [
        {
          seq: 1,
          cashDsbrVchNo: this.$route.params.id ? this.$route.params.id : 3000,
          subject: "",
          userNm: "",
          summary: "",
          amt: "",
          cash: "",
          // ...this.initRows,
        },
      ],
      data: [],
      total: 0,
      totalNum: 0,
      files: [],
      resFiles: [],
      selYear: new Date().getFullYear().toString(),
      selMonth: moment().format("MM"),
      snackbar: { show: false, message: "" },
    };
  },
  computed: {
    isModify() {
      return this.$route.params.id ? true : false;
    },
    today() {
      if (this.$route.params.id) {
        return this.data.wrDt;
      }
      return moment().format("YYYY-MM-DD");
    },
    // years() {
    //   const max = new Date().getFullYear();
    //   const min = max - 9;
    //   const years = [];

    //   for (let i = max; i >= min; i--) {
    //     years.push(i.toString());
    //   }

    //   return years;
    // },
    // months() {
    //   const months = [];
    //   for (let i = 1; i <= 12; i++) {
    //     let month = i.toString();
    //     if (month.length !== 2) {
    //       month = 0 + month;
    //     }
    //     months.push(month);
    //   }
    //   return months;
    // },
  },
  mixins: [SetComma, getDates],
  created() {
    if (this.isModify) {
      this.loadDetail();
    }
  },
  methods: {
    async loadDetail() {
      try {
        const { data } = await detailDsbr(this.$route.params.id);
        const newRows = data.form.itemList.map(v => {
          return {
            ...v,
            modYn: "N",
            cash: this.comma(v.amt),
          };
        });

        this.data = data.form;
        this.rows = newRows;
        this.total = this.comma(data.form.sumAmt);
        this.selYear = data.form.imptYm.substring(0, 4);
        this.selMonth = data.form.imptYm.substring(4, 6);
        // this.files = data.form.fileList.map(v => v.fileNm);
      } catch (error) {
        console.error(error.response.data.message);
      }
    },
    addDropFile(e) {
      this.files = Array.from(e.dataTransfer.files);
      this.changeFiles(this.files);
    },
    changeFiles(files) {
      files.forEach(async (file, i) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("name", file.name);
        formData.append("seq", i);
        formData.append("fileLoc", 1);
        formData.append("idNo", 1);

        try {
          // formData send
          const { data } = await uploadFile(formData);
          this.resFiles.push(data.fileNo);
        } catch (error) {
          console.error(error.response.data.message);
        }
      });
    },
    addRows() {
      this.rows.push({
        seq: this.rows.length + 1,
        cashDsbrVchNo: 3000,
        ...this.initRows,
      });
    },
    removeRow(id) {
      let deleteRow = this.rows.filter(v => id !== v.id);
      deleteRow = deleteRow.map((v, i) => {
        v.id = i + 1;
        return v;
      });
      this.rows = deleteRow;
    },
    handleChangeRows(seq) {
      // 수정모드일 때 modYn 표시
      if (!this.isModify) {
        return null;
      }
      const changeRows = this.rows.map(v => {
        if (v.seq === seq) {
          v.modYn = "Y";
        }
        return v;
      });
      this.rows = changeRows;
    },
    sumTotal(seq) {
      this.handleChangeRows(seq);
      let total = 0;
      this.rows.forEach(v => {
        if (v.amt) {
          total += v.amt;
        }
      });
      this.total = this.comma(total);
    },
    setComma(id, str) {
      const uncommaStr = this.uncomma(str);
      const comma = this.comma(uncommaStr);

      const newRows = this.rows.map(v => {
        if (v.seq === id) {
          v.cash = comma;
          v.amt = Number(uncommaStr);
        }

        return v;
      });

      this.rows = newRows;
    },
    async onSubmit() {
      this.$refs.form.validate();
      if (!this.valid) return false;

      let res;
      try {
        if (this.isModify) {
          // 수정
          const postData = {
            cashDsbrVchNo: this.$route.params.id,
            empNo: this.data.empNo,
            sumAmt: Number(this.uncomma(this.total)),
            wrDt: moment(this.data.wrDt).format("YYYYMMDD"),
            note: this.data.note,
            imptYm: this.selYear + this.selMonth,
            fileNo: this.resFiles,
            itemList: this.rows,
          };

          res = await modyDsbr(this.$route.params.id, postData);
        } else {
          // 등록
          const postData = {
            empNo: 200,
            sumAmt: Number(this.uncomma(this.total)),
            wrDt: moment().format("YYYYMMDD"),
            imptYm: this.selYear + this.selMonth,
            fileNo: this.resFiles,
            itemList: this.rows,
          };

          res = await setDsbr(postData);
        }

        if (res.data.ret === 1) {
          this.snackbar.message = "저장에 성공했습니다.";
          this.snackbar.show = true;

          setTimeout(() => {
            const path = this.$route.params.id
              ? `/approval/view/${this.$route.params.id}`
              : `/approval/view/${res.data.id}`;

            this.$router.push(path);
          }, 500);
        } else {
          this.snackbar.message = "저장에 실패했습니다.";
          this.snackbar.show = true;
        }
      } catch (error) {
        console.error(error.response.data.message);
      }
    },
  },
};
</script>

<style></style>
